import { linksEncuestasFormModel } from './linksEncuestasFormModel';

const {
    formField: {
        name,
        description,
        surveyId,
        userId,
        fechaEvento,
        nombreEvento,
        nombreCliente,
        telefonoCliente,
        emailCliente,
        diaNacimiento,
        mesNacimiento,
        shareTemplate
    }
} = linksEncuestasFormModel;

export const initialValues = {
    [name.name]: '',
    [description.name]: '',
    [surveyId.name]: null,
    [userId.name]: null,
    [fechaEvento.name]: '',
    [nombreEvento.name]: '',
    [nombreCliente.name]: '',
    [telefonoCliente.name]: '',
    [emailCliente.name]: '',
    [diaNacimiento.name]: '',
    [mesNacimiento.name]: '',
    [shareTemplate.name]: null
};
